<template>
    <div v-if="value">
        <div v-if="curr.dock == 'window'" class="dockwin"
            :style="{ top: curr.pos.y + 'px', left: curr.pos.x + 'px', width: curr.size.x + 'px' }">
            <b-card >
                <div draggable="true" class="widthdrag"
                    :style="{ position: 'absolute', left: curr.size.x - 5 + 'px', width: '5px', 'height': curr.size.y + 'px' }"
                    v-on:drag="movesize($event)"></div>
                <b-card-header>
                    <div draggable="true" v-on:drag="movepos($event)" v-on:drop="drop($event)">
                        <!-- <b-icon-arrows-move></b-icon-arrows-move>
                        {{ curr.size.x }} -->
                        <b-icon-x class="close text-dark clickable" @click="close()"></b-icon-x>
                        <b-dropdown right size="sm" variant="light" title="Detaljfönsterläge">
                            <template #button-content>
                                <b-icon-layout-text-window></b-icon-layout-text-window>
                            </template>
                            <b-dropdown-item v-for="d in dockmodes" :key="d.mode" @click="SetDockMode(d)">
                                <b-icon :icon="d.icon"></b-icon> {{ d.title }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item @click="ResetLayout()">Återställ</b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <slot name="modal-title"></slot>
                </b-card-header>
                <b-card-body>                   
                    <slot></slot>                
                </b-card-body>
            </b-card>
        </div>
        <b-sidebar v-if="curr.dock == 'sidebar-right' || curr.dock == 'sidebar-left'" id="sidebar"
            :right="curr.dock == 'sidebar-right'" shadow v-model="value" :width="curr.size.x + 'px'">
            <b-card>
                <b-card-header>
                    <b-dropdown right text="Menu" size="sm" variant="light">
                        <template #button-content>
                            <b-icon-layout-text-window></b-icon-layout-text-window>
                        </template>
                        <b-dropdown-item v-for="d in dockmodes" :key="d.mode" @click="SetDockMode(d)">
                            <b-icon :icon="d.icon"></b-icon> {{ d.title }}
                        </b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="ResetLayout()">Återställ</b-dropdown-item>
                    </b-dropdown>
                    <slot name="modal-title"></slot>
                </b-card-header>
                <b-card-body>
                    <slot></slot>
                </b-card-body>
            </b-card>
        </b-sidebar>
    </div>
</template>
<script>
//   import lmodal from "@/components/l-modal.vue";

//   import queryview from "@/views/queryview/queryview";

export default {
    name: 'lmodal',
    props: { value: Boolean, domain: String },
    // components: { queryview, lmodal },
    data() {
        return {
            dockmodes: [
                { mode: 'window', title: 'Egen ruta', icon: 'layers' },
                { mode: 'sidebar-left', title: 'Låst till vänster', icon: 'box-arrow-left' },
                { mode: 'sidebar-right', title: 'Låst till höger', icon: 'box-arrow-right' },
            ],
            curr: null,
            dragstart: null,
            sizedragstart: null,
        }
    },
    created() {
        this.GetSettingsFromStorage();
    },
    methods: {
        movepos(e) {
            console.log('movepos');
            if (e.pageX <= 0) {
                this.SaveSettings();
                e.preventDefault();
                return;
            }
            if (!this.dragstart)
                this.dragstart = { x: this.curr.pos.x - e.pageX, y: this.curr.pos.y - e.pageY };

            this.curr.pos.x = this.dragstart.x + e.pageX;
            this.curr.pos.y = this.dragstart.y + e.pageY;
        },
        movesize(e) {
            console.log(e);
            if (e.pageX <= 0) { //End
                this.SaveSettings();
                e.preventDefault();
                return;
            }
            if (!this.sizedragstart)
                this.sizedragstart = { x: this.curr.size.x - e.pageX };

            this.curr.size.x = this.sizedragstart.x + e.pageX;
            e.preventDefault();
        },
        close() {
            this.$emit('input', false);
            this.$emit('close', false);
        },
        SetDockMode(d) {
            this.curr.dock = d.mode;
            this.SaveSettings();
        },
        SaveSettings() {
            localStorage.setItem('layout_' + this.domain, JSON.stringify(this.curr));
        },
        GetSettingsFromStorage() {
            var s = localStorage.getItem('layout_' + this.domain);
            if (s)
                this.curr = JSON.parse(s);
            else
                this.curr = {
                    pos: { x: 20, y: 30 },
                    size: { x: 1000, y: 550 },
                    dock: 'window'
                }
        },
        ResetLayout() {
            localStorage.removeItem('layout_' + this.domain);
            this.GetSettingsFromStorage();
        }
    }
}
</script>
<style scoped>
.widthdrag {
    width: 6px;
    top: 0;
    z-index: 9999;
    cursor: ew-resize;
    /* background-color: transparent; */
    background-color: color;
}

.dockwin {
    position: absolute;
    z-index: 1040;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);    
    /* overflow-y: auto;
    overflow-x: hidden; */
}
</style>